import { en } from './en';
import { he } from './he';

export const headerTranslations = {
  en,
  he
};

export type HeaderTranslationKey = keyof typeof headerTranslations;
export type HeaderTranslation = typeof headerTranslations.he; 